import _ from 'lodash';

import configureStore from 'redux/_reducer/configureStore';

/** Returns section from Redux Store without reactive handling */
const getFromStore = <T>(path: string) => _.get(configureStore.getState(), path) as T;

export default getFromStore;
